import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";
import { getPageAnalytics } from "./getPageAnalytics";

const ANALYTICS_PAGE_TYPE_PLACEHOLDER = "<!--%analyticsPageType%-->";

export const PRODUCT_PAGE_TYPE = "product page";

/**
 * Resolves the analytics page type of the current page.
 *
 * Uses the same sources, in the same order, as updatePageScopedAnalytics:
 * 1. the analytics div rendered by the hosting application (getPageAnalytics)
 * 2. the `mixpanelSuperProperties` the hosting application rendered into the
 *    window namespace via the `<!--%analyticsPageType%-->` placeholder
 *
 * @returns {string|undefined} the page type, or undefined when it is unknown
 */
export const getAnalyticsPageType = () => {
  const fromNamespace =
    window[asosGlobalNamespace]?.[siteChromeGlobalNamespace]
      ?.mixpanelSuperProperties?.analyticsPageType;

  const { analyticsPageType = fromNamespace } = getPageAnalytics();

  if (
    !analyticsPageType ||
    analyticsPageType === ANALYTICS_PAGE_TYPE_PLACEHOLDER
  ) {
    return undefined;
  }

  return analyticsPageType;
};

/**
 * @returns {boolean} true when the current page is a product detail page
 */
export const isProductPage = () => getAnalyticsPageType() === PRODUCT_PAGE_TYPE;
